import * as React from "react";
import { cn } from "lib/utils";
import "./styles.css";


function getMessagePageWrapperColorStyle(color = "primary") {
  return {
    "--mp-color-50": `var(--${color}-50)`,
    "--mp-color-100": `var(--${color}-100)`,
    "--mp-color-200": `var(--${color}-200)`,
    "--mp-color-500": `var(--${color}-500)`,
    "--mp-color-700": `var(--${color}-700)`,
    backgroundColor: `var(--${color}-50)`,
  };
}

export function MessagePageWrapper({ color = "primary", className, style, children, ...props }) {
  return (
    <div
      className={cn("ls-message-page-wrapper", className)}
      style={{ ...getMessagePageWrapperColorStyle(color), ...style }}
      {...props}
    >
      {children}
    </div>
  );
}
